import * as ng from 'angular';
import { Account, IAccountResource } from './account';
import { Country, ICountryResource } from './country';
import { CreditCard, ICreditCardResource } from './credit-card';
import { FrequentParkerAccount, IFrequentParkerAccountResource } from './frequent-parker-account';
import { ParkingArea, IParkingAreaResource } from './parking-area';
import { ParkingMedia, IParkingMediaResource } from './parking-media';
import { ParkingMediaRequest, IParkingMediaRequestResource } from './parking-media-request';
import { ParkingMediaType, IParkingMediaTypeResource } from './parking-media-type';
import { Profile, IProfileResource } from './profile';
import { Settings, ISettingsResource } from './settings';
import { Subdivision, ISubdivisionResource } from './subdivisions';
import { ContentTemplate, IContentTemplateResource } from './content-template';
import { ContentTemplateWrite, IContentTemplateWriteResource } from './content-template-write';
import { ContentTypeSettings, IContentTypeSettingsResource } from './content-type-settings';
import CoreModule from '../core';
import * as Dto from './interfaces';
import TransactionTypes from './transaction-types';
import FrequentParkerActivityTypes from './frequent-parker-activity-types';
import {CreditCardTicket, ICreditCardTicketResource} from "./credit-card-ticket";
import {ReCaptchaValidation, IReCaptchaValidationResource} from "./recaptcha-validation";


let dataModule = ng.module("app.data", [
    'ngResource',
    CoreModule.name

]).factory(Account.name, Account.factory)
    .factory(Country.name, Country.factory)
    .factory(CreditCard.name, CreditCard.factory)
    .factory(CreditCardTicket.name, CreditCardTicket.factory)
    .factory(ReCaptchaValidation.name, ReCaptchaValidation.factory)
    .factory(FrequentParkerAccount.name, FrequentParkerAccount.factory)
    .factory(ParkingArea.name, ParkingArea.factory)
    .factory(ParkingMedia.name, ParkingMedia.factory)
    .factory(ParkingMediaRequest.name, ParkingMediaRequest.factory)
    .factory(ParkingMediaType.name, ParkingMediaType.factory)
    .factory(Profile.name, Profile.factory)
    .factory(Settings.name, Settings.factory)
    .factory(Subdivision.name, Subdivision.factory)
    .factory(ContentTemplate.name, ContentTemplate.factory)
    .factory(ContentTemplateWrite.name, ContentTemplateWrite.factory)
    .factory(ContentTypeSettings.name, ContentTypeSettings.factory);

export {
    dataModule as DataModule,
    IAccountResource, ICountryResource, ICreditCardResource, IFrequentParkerAccountResource,
    IParkingAreaResource, IParkingMediaResource, IParkingMediaRequestResource,
    IParkingMediaTypeResource, IProfileResource, ISettingsResource, ISubdivisionResource,
    IContentTemplateResource, IContentTypeSettingsResource, Dto, ICreditCardTicketResource, IReCaptchaValidationResource,
    TransactionTypes, FrequentParkerActivityTypes
};
export default dataModule;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/data/index.ts